import { DEAL_OBJECT_ID } from '../../constants/CrmSearchConstants';
import PropertyHeader from '../frameworkDealTable/PropertyHeader';
import CloseDateCell from './CloseDateCell';
import DealAmountCell from './DealAmountCell';
import DealNameCell from './DealNameCell';
import DealScoreCell from './DealScoreCell';
import PropertyEditCellWrapper from './PropertyEditCellWrapper';
import { DEAL_PROPERTIES } from '../../constants/CrmSearchConstants';
import ForecastedCell from './ForecastedCell';
import ForecastedCellPropertyHeader from '../frameworkDealTable/ForecastedCellPropertyHeader';
const ColumnToCellMap = {
  [DEAL_PROPERTIES.CLOSE_DATE]: CloseDateCell,
  [DEAL_PROPERTIES.DEAL_NAME]: DealNameCell,
  [DEAL_PROPERTIES.DEAL_SCORE]: DealScoreCell
};
const ColumnToCellMapForDefaultForecastAmount = {
  [DEAL_PROPERTIES.AMOUNT]: DealAmountCell,
  [DEAL_PROPERTIES.AMOUNT_IN_HOME_CURRENCY]: DealAmountCell,
  [DEAL_PROPERTIES.WEIGHTED_AMOUNT]: DealAmountCell,
  [DEAL_PROPERTIES.WEIGHTED_AMOUNT_IN_HOME_CURRENCY]: DealAmountCell
};
const WEIGHTED_FORECAST_AMOUNT_PREFIX = 'hubspot_weighted_';
const getColumnToCellMap = forecastAmountProperty => {
  const isDefaultForecastAmount = !forecastAmountProperty || forecastAmountProperty === DEAL_PROPERTIES.AMOUNT;

  // If we are using "amount" as the forecast's amount property, we want to use the DealAmountCell renderer
  // for the four properties contained in ColumnToCellMapForDefaultForecastAmount
  if (isDefaultForecastAmount) {
    return Object.assign({}, ColumnToCellMap, ColumnToCellMapForDefaultForecastAmount);
  }
  // For any other  amount property, we want to use the DealAmountCell renderer for that property and its weighted equivalent
  return Object.assign({}, ColumnToCellMap, {
    [forecastAmountProperty]: DealAmountCell,
    [`${WEIGHTED_FORECAST_AMOUNT_PREFIX}${forecastAmountProperty}`]: DealAmountCell
  });
};
export const getCellForColumn = (columnName, forecastAmountProperty) => {
  const columnToCellMap = getColumnToCellMap(forecastAmountProperty);
  return columnToCellMap[columnName] || PropertyEditCellWrapper;
};
export const mapColumns = (columns, propertyDefinitions, columnWidths, isUngatedToManualSubmissionOverhaul, forecastAmountProperty) => {
  const updatedColumns = columns.reduce((acc, column) => {
    var _columnWidths$column;
    if (!propertyDefinitions[column]) {
      return acc;
    }
    acc.push({
      CellComponent: getCellForColumn(column, forecastAmountProperty),
      columnName: column,
      columnNamespace: DEAL_OBJECT_ID,
      HeaderContentComponent: PropertyHeader,
      reorderable: false,
      sortable: true,
      width: (_columnWidths$column = columnWidths[column]) !== null && _columnWidths$column !== void 0 ? _columnWidths$column : 250
    });
    return acc;
  }, []);
  if (isUngatedToManualSubmissionOverhaul) {
    // Add forecasted cell
    updatedColumns.unshift({
      CellComponent: ForecastedCell,
      columnName: DEAL_PROPERTIES.FORECASTED,
      columnNamespace: DEAL_OBJECT_ID,
      HeaderContentComponent: ForecastedCellPropertyHeader,
      reorderable: false,
      sortable: false,
      width: 125
    });
  }
  return updatedColumns;
};